import { loadAsyncComponents } from '../shared/loadComponents';

// 使用懒加载方式，提升首屏加载性能
const modules = import.meta.glob('./*/index.(tsx|vue)');

export default loadAsyncComponents(modules);
